import React from 'react';

import type GraphQL from '~/types/graphql';

import BasicIcon, {
	BasicIconType,
} from '~/components/patterns/icons/BasicIcon';
import Button, {
	ButtonStyle,
} from '~/components/patterns/buttons/Button';
import ExportForm from './ExportForm';
import PopupButton, {
	PopupButtonSize,
	PopupButtonStyle,
} from '~/components/patterns/buttons/PopupButton';

import useViewportType from '~/hooks/useViewportType';

import {
	getRouterState,
} from '~/routing/router';
import goTo from '~/routing/goTo';



type Props = {
	createExport: (format: GraphQL.ExportFormat) => Promise<{
		exportDownloadUrl: string,
		exportFilename: string,
		exportId: number,
		isLarge: boolean,
	}>,
	linkLabel: React.ReactNode,
};

const ExportHeaderButton: React.FC<Props> = (props) => {
	const {
		createExport,
		linkLabel,
	} = props;

	const popupButtonRef = React.useRef<PopupButton | null>(null);
	const viewportType = useViewportType();

	const handleClosePopup = React.useCallback(
		() => {
			popupButtonRef.current?._handleClosePopup();
		},
		[
			popupButtonRef,
		],
	);

	const handleOpenMobileExport = React.useCallback(
		(e) => {
			e.preventDefault();
			const routerState = getRouterState();
			goTo(e, `${routerState.name}.export`, routerState.params);
		},
		[],
	);

	if (viewportType.isSmall) {
		return (
			<Button
				icon={(
					<BasicIcon type={BasicIconType.Export} />
				)}
				onClick={handleOpenMobileExport}
				style={ButtonStyle.Hollow}
			/>
		);
	}

	return (
		<PopupButton
			buttonIcon={(
				<BasicIcon type={BasicIconType.Export} />
			)}
			label={linkLabel}
			popupZIndex={1990}
			preventOutsideClickCallback={(target) => {
				const popup = target.closest('.simple-nav');
				return popup !== null;
			}}
			ref={popupButtonRef}
			size={PopupButtonSize.Small}
			style={PopupButtonStyle.Hollow}
			uppercase={true}
		>
			<ExportForm
				createExport={createExport}
				onCancelCallback={handleClosePopup}
			/>
		</PopupButton>
	);
};



export default ExportHeaderButton;
